import type * as React from "react";
import type { ToolkitCollection } from "@/clients/arcade/arcade";
import {
  type ToolkitPickerInitialProps,
  ToolkitPickerProvider,
} from "./hooks/use-toolkit-picker";
import { ToolkitPickerDialog } from "./toolkit-picker";

export type SelectionMode = "multi" | "single";

export type ToolkitPickerProps = {
  onSelectionChange?: (args: {
    selectedToolkits: string[];
    selectedTools: string[];
  }) => void;
  defaultToolFqns?: string[];
  onSearchEmpty?: (query: string) => void;
  toolkitCollection: ToolkitCollection | undefined;
  description?: string;
  children: React.ReactElement;
  selectionMode?: SelectionMode;
  initialProps?: ToolkitPickerInitialProps;
};

export function ToolkitPicker(props: ToolkitPickerProps) {
  return (
    <ToolkitPickerProvider
      initialProps={props.initialProps}
      onSearchEmpty={props.onSearchEmpty}
      selectionMode={props.selectionMode}
      toolkitCollection={props.toolkitCollection}
    >
      <ToolkitPickerDialog {...props} />
    </ToolkitPickerProvider>
  );
}
